import { MDBAlert } from "mdb-react-ui-kit";
import { useEffect, useRef, useState } from "react";
import { getMisc, sendSMSEnableAPIRequest } from "../../../apiclients/streamsapi_bridge";
import PopupLoader from "../PopupLoader";
import { AddRemoveNumbers, unFormatNumber } from "./AddRemoveNumbers";
import PopupLoaderNew from "../PopupLoaderNew";

export default function SMSEnabledRequest({ onClose, campaignFlag, setSuccessMessage }) {

    const [selectNumbers, setSelectedNumbers] = useState([]);
    const [nonSMSNumList, setNonSMSNumList] = useState([]);
    const [updateNumbersExecuted, setUpdateNumbersExecuted] = useState(false);
    const [SMSEnableRequest, setSMSEnableRequest] = useState(true);

    const SMSEnableRequesttoggleOpen = () => { setSMSEnableRequest(!SMSEnableRequest); };
    const addNumberRef = useRef(null);
    const [isLoading, setisLoading] = useState(false);

    function handleClick() {
        addNumberRef.current.click();
    }


    async function getNonSmsEnabledNum() {
        try {
            const response = await getMisc(JSON.parse(sessionStorage.getItem("admin_session")).siteid, { misc: ["account_non_sms_numbers"] });
            if (response.status == 200) {
                const resdata = await response.json();
                setNonSMSNumList(resdata.misc?.account_non_sms_numbers);
            }
        } catch (error) {
            console.error(`Unable to fetch the info:${error}`);
        }

    }

    async function sendSMSEnableReq(Phnumbers) {
        try {
            console.log(`phonenumbers::${Phnumbers}`);

            //  Phnumbers = Phnumbers.map(num => unFormatNumber(num));

            let apiResponse = await sendSMSEnableAPIRequest({
                reqid: 98,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                phone_numbers: Phnumbers
            });
            let resdata = await apiResponse.json();
            if (apiResponse.status == 200) {
                if (campaignFlag) {
                    setSuccessMessage(resdata.message);
                } else {
                    localStorage.setItem("s_message", resdata.message);
                }
            } else if (apiResponse.status == 500) {
                if (campaignFlag) {
                    setSuccessMessage(resdata.message);
                } else {
                    localStorage.setItem("f_message", "Internal Server Error");
                }
            } else {
                console.log(JSON.stringify(resdata.message.errors));
                if (campaignFlag) {
                    setSuccessMessage(resdata.message);
                } else {
                    localStorage.setItem("f_message", resdata.message.errors[0].message);
                }


            }
        } catch (error) {
            console.log(`Unable to send sms enable request::${error}`)
            localStorage.setItem("f_message", "Internal Server Error");
        }
        if (!campaignFlag) {
            window.location.href = "/phonenumbers";
        }
        onClose();
    }

    useEffect(() => {
        getNonSmsEnabledNum();
        setSMSEnableRequest(true);
    }, []);


    useEffect(() => {
        console.log(`${updateNumbersExecuted} ::Adding data:${selectNumbers}`);
        if (updateNumbersExecuted && selectNumbers?.length > 0) {
            sendSMSEnableReq(selectNumbers);
        }
    }, [updateNumbersExecuted]);


    useEffect(() => {
        if (SMSEnableRequest == false) {
            onClose();
        }
    }, [SMSEnableRequest]);

    return (
        <>{SMSEnableRequest && (

            <PopupLoaderNew
                title={"SMS Enable Request"}
                content={
                    <AddRemoveNumbers
                        selectedNum={selectNumbers}
                        setUpdatePHNum={setSelectedNumbers}
                        setUpdateNumbersExecuted={setUpdateNumbersExecuted}
                        sourceNumber={nonSMSNumList}
                        onClose={SMSEnableRequesttoggleOpen}
                        // sendText={"send"}
                        ref={addNumberRef}
                        setIsloading={setisLoading}
                    />
                }
                onShow={setSMSEnableRequest}
                onClose={SMSEnableRequesttoggleOpen}
                onSave={handleClick}
                isloading={isLoading}
                flag={8}
            />
        )

        }

        </>
    );



}